import { Info } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/atoms';
import { cn } from '@/lib/utils';

/** Shared info-tip icon color for field help tooltips across the app. */
export const INFO_TIP_ICON_CLASS = 'text-[var(--color-amber-500)]';

export interface InfoTipProps {
  content: string;
  ariaLabel: string;
  className?: string;
}

export function InfoTip({ content, ariaLabel, className }: InfoTipProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          className={cn(
            'inline-flex shrink-0 rounded-full opacity-90 hover:opacity-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40',
            INFO_TIP_ICON_CLASS,
            className
          )}
          aria-label={ariaLabel}
        >
          <Info className="size-3.5" />
        </button>
      </TooltipTrigger>
      <TooltipContent
        sideOffset={6}
        className="w-auto max-w-[min(18rem,calc(100vw-2.5rem))] whitespace-normal text-left leading-relaxed shadow-md"
      >
        {content}
      </TooltipContent>
    </Tooltip>
  );
}
